import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { CommonService, Shared } from '@rubii/frontend-common';
import { FormControl, Validators } from '@angular/forms';
import { ConfigService } from '../../../services/config.service';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { GoogleUserProfileInterface } from '../../interfaces/GoogleUserProfileInterface';
import { GoogleAgencyInterface } from '../../interfaces/GoogleAgencyInterface';
import { Dsps } from '@rubii/share/src/constants';
import { ClientService } from '../../../services/client.service';
import { HttpException } from '@rubii/share/src/classes';


@Component({
  selector: 'app-dcm',
  templateUrl: './dcm.component.html',
  styleUrls: ['./dcm.component.scss']
})
export class DcmComponent extends BaseDatasourceComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { dataSourceId: number, userProfilesOrAgencies: GoogleUserProfileInterface[] | GoogleAgencyInterface[] }, private client: ClientService, private config: ConfigService, private snackBar: MatSnackBar, private dialogRef: MatDialogRef<DatasourceConnectionComponent>) {
    super();
  }

  ngOnInit() {
    this.partnerIds = new FormControl('', [Validators.required]);
  }

  connect() {
    
    this.client.account.addPartnerIds({dataSourceId: Dsps.CM, partnerIds: this.partnerIds.value})
      .then(result => {
        this.openSnackBar(this.snackBar, 'Data source connected.', 'closed'); 
        this.dialogRef.close({dataSourceId: Dsps.CM});
      })
      .catch(e => this.openSnackBarWarning(this.snackBar, (e as HttpException).message, 'closed'));
  }
}
